export default __webpack_public_path__ + "static/media/ClockIcon.fd479761.svg";